module.exports = __webpack_public_path__ + "img/download-on-app-gallery@3x.3faedda9.png";